<template>
  <div id="shipping-address">
    <div class="title semibold mb-4">Billing Information</div>
    <v-text-field label="First Name" v-model="user.billing_address.first_name"></v-text-field>
    <v-text-field label="Last Name" v-model="user.billing_address.last_name"></v-text-field>
    <v-text-field label="Company Name" v-model="user.billing_address.company"></v-text-field>
    <v-text-field label="Phone Number" v-model="user.billing_address.phone"></v-text-field>
    <v-text-field label="Email" v-model="user.billing_address.email"></v-text-field>

    <v-text-field label="Street 1" v-model="user.billing_address.street1"></v-text-field>
    <v-text-field label="Street 2" v-model="user.billing_address.street2"></v-text-field>
    <v-text-field label="City" v-model="user.billing_address.city"></v-text-field>
    <v-text-field label="State" v-model="user.billing_address.state"></v-text-field>
    <v-text-field label="ZIP" v-model="user.billing_address.zip"></v-text-field>
    <v-text-field label="Country" v-model="user.billing_address.country"></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    user: Object
  }
}
</script>



// WEBPACK FOOTER //
// billing-address.vue?3f2a33ea